import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=ed5e9b9c&scoped=true"
import script from "./Logo.js?vue&type=script&lang=js&external"
export * from "./Logo.js?vue&type=script&lang=js&external"
import style0 from "./Logo.vue?vue&type=style&index=0&id=ed5e9b9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5e9b9c",
  null
  
)

export default component.exports